import {all} from 'redux-saga/effects';

import {authSagas} from '../modules/auth';
import {lockersSagas} from '../modules/lockers';
import {usersSagas} from '../modules/users';

export default function* rootSaga() {
	yield all([...authSagas, ...lockersSagas, ...usersSagas]);
}
